import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-select {
    display: flex;
    .ant-row {
      .ant-form-item-control {
        .ant-form-item-explain-error {
          width: 177px;
        }
      }
    }
  }
  .titleSiteName {
    margin-left: 8px;
    color: #000000;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }
  .group-input {
    padding: 0 24px 16px 24px;
    .ant-form-item {
      flex-direction: row;
      display: flex;
      &.note-field {
        margin-bottom: 0;
      }
      .ant-form-item-label {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0;
        .ant-form-item-no-colon {
          color: #000000;
          min-width: 110px;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
        }
      }
    }
    .select-field {
      min-width: 400px;
    }
  }
  .ant-modal-footer {
    .ant-btn-primary {
      margin-left: 16px !important;
    }
  }

  .select-date {
    width: 177px;
  }
  .center-text {
    padding: 6px 16px 0 16px;
  }
`;

export const HeaderStyle = styled.div`
  display: flex;
  flex-direction: row;
  img {
    margin-right: 16px;
  }
`;
